module.exports = __webpack_public_path__ + "static/media/location12.5c0e5e72.jpg";